import React from 'react';

/**
 * Reusable slot for the left side of the app top bar (dashboard, settings, Symptoms Profile,
 * cervical proprioception, Ask Dr Schmoe, etc.). Default: empty space.
 * Later you can pass children (e.g. company logo, text, or banner) or switch by route.
 */
const TopBarBrand: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <>{children ?? null}</>;
};

export default TopBarBrand;
